/**
 * @generated SignedSource<<9bc89395da9ea2d24a6da9eb6532cee5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type DatasetHelmetFragment$data = {
  readonly createdAt: DateTime;
  readonly name: string;
  readonly private: boolean;
  readonly shortDescription: string | null | undefined;
  readonly slug: string;
  readonly tags: {
    readonly nodes: ReadonlyArray<{
      readonly name: string;
    }>;
  };
  readonly version: {
    readonly authors: {
      readonly nodes: ReadonlyArray<{
        readonly displayName?: string;
      }>;
    };
    readonly doi: {
      readonly full: string;
      readonly url: Url;
    } | null | undefined;
    readonly files: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly size: number;
      }>;
    };
    readonly license: string | null | undefined;
    readonly publishedAt: DateTime | null | undefined;
    readonly updatedAt: DateTime;
  } | null | undefined;
  readonly " $fragmentType": "DatasetHelmetFragment";
};
export type DatasetHelmetFragment$key = {
  readonly " $data"?: DatasetHelmetFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatasetHelmetFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DatasetHelmetFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    {
      "alias": "version",
      "args": null,
      "concreteType": "DatasetVersion",
      "kind": "LinkedField",
      "name": "latestVersion",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publishedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "license",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DatasetVersionAuthorConnection",
          "kind": "LinkedField",
          "name": "authors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "displayName",
                      "storageKey": null
                    }
                  ],
                  "type": "User",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "displayName",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    }
                  ],
                  "type": "UnregisteredUser",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DatasetVersionFileConnection",
          "kind": "LinkedField",
          "name": "files",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DatasetVersionFile",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "size",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DOI",
          "kind": "LinkedField",
          "name": "doi",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "full",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaggableConnection",
      "kind": "LinkedField",
      "name": "tags",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "Dataset",
  "abstractKey": null
};
})();

(node as any).hash = "8876f11ec5a2d7841ee9e5e60a69eaa7";

export default node;
